import type { TiptapEditorPlugin } from 'ricos-types';

import { tab } from './extension';

export const pluginTab: TiptapEditorPlugin = {
  type: 'TAB',
  config: {},
  tiptapExtensions: [tab],
};
